import { TNotification } from 'src/providers/notification.provider'
import * as Sentry from '@sentry/browser'

const generateRandomPassword = (): string | undefined => {
  if (typeof window.crypto.getRandomValues !== 'undefined') {
    return window.crypto.getRandomValues(new BigUint64Array(1))[0]?.toString(36)
  }
}

const getFormSubmitNotificationError = (errorMessage: string, t: any): TNotification => {
  if (errorMessage === 'User.email is already taken') {
    return {
      title: t('pages.auth.wording.fail'),
      message: t('pages.auth.notification.email-is-already-taken'),
      appearance: 'ERROR',
    }
  }
  if (errorMessage === 'Insufficient permissions to update this user.') {
    return {
      title: t('pages.auth.wording.fail'),
      message: t('pages.users-page.notify-Insufficient-permissions'),
      appearance: 'ERROR',
    }
  }

  let message = t(`pages.auth.notification.${errorMessage}`)
  if (message.includes('pages.auth.notification')) {
    // No translation has been found, defaults to a generic translated error message
    Sentry.captureException(`No translation found for: ${message}`)
    message = t(`pages.auth.error.server`)
  }
  return {
    title: t('pages.auth.wording.fail'),
    message: message,
    appearance: 'ERROR',
  }
}

export { generateRandomPassword, getFormSubmitNotificationError }
